import React from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <div className="w-full min-h-screen bg-black" data-id="element-0">
      <SalesPage data-id="element-1" />
    </div>;
}